import { ActionRow, ADMIN_TAG, SettingsCard, ToggleRow } from '../SettingsKit'

export default function ContentFetchingTab() {
    return (
        <>
            <SettingsCard title="Authorisation">
                <ActionRow
                    label="Profile authorisation"
                    description="Authorised ✓ — automations are enabled for this profile."
                    action="Re-authorise"
                />
            </SettingsCard>

            <SettingsCard title="Capture" badges={ADMIN_TAG}>
                <ToggleRow
                    label="Screenshots"
                    description="Automatically capture visual snapshots of content for moderation and record-keeping."
                    defaultOn
                />
            </SettingsCard>

            <SettingsCard
                title="YouTube"
                description="Content-fetching settings for this YouTube profile."
            >
                <ToggleRow
                    label="Fetch with API"
                    badges={ADMIN_TAG}
                    description="Fetch content in the background from today using the YouTube API."
                    defaultOn
                />
                <ActionRow
                    label="Subscription diagnostics"
                    badges={ADMIN_TAG}
                    description="Open the YouTube subscription diagnostic for this profile."
                    action="Open"
                />
                <ActionRow
                    label="Fetch historic videos"
                    badges={ADMIN_TAG}
                    description="Fetch up to 5 years of historic videos. Can take up to 45 minutes."
                    action="Fetch"
                />
                <ActionRow
                    label="Revoke authorisation"
                    badges={ADMIN_TAG}
                    description="Disconnect this profile from the YouTube API."
                    action="Revoke"
                    danger
                />
            </SettingsCard>

            <SettingsCard
                title="Meta (Facebook & Instagram)"
                description="Shown for Meta profiles."
            >
                <ToggleRow
                    label="Fetch posts"
                    badges={ADMIN_TAG}
                    description="Continuously fetch new and existing organic posts for this profile."
                />
                <ToggleRow
                    label="Fetch ads"
                    badges={ADMIN_TAG}
                    description="Continuously fetch active ads (stored as posts) so Arwen can detect ad comments."
                />
                <ActionRow
                    label="Fetch last 24 hours"
                    badges={ADMIN_TAG}
                    description="Backfill content from the last 24 hours for this Meta profile."
                    action="Fetch"
                />
            </SettingsCard>

            <SettingsCard title="Instagram" description="Shown for Instagram profiles.">
                <ToggleRow
                    label="Profile collection"
                    badges={ADMIN_TAG}
                    description="Collect and classify commenter profiles."
                />
                <ToggleRow
                    label="Profile moderation"
                    badges={ADMIN_TAG}
                    description="Moderate and classify commenter profiles."
                />
            </SettingsCard>

            <SettingsCard title="Direct messages" description="Shown for Facebook profiles.">
                <ToggleRow
                    label="Direct messages"
                    badges={ADMIN_TAG}
                    description="Enable DM moderation for this profile."
                />
                <ActionRow
                    label="Fetch conversations"
                    badges={ADMIN_TAG}
                    description="Pull existing DM conversations. Requires direct messages to be enabled."
                    action="Fetch"
                />
            </SettingsCard>
        </>
    )
}
